/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * DDEX producer copyright line
 * @export
 * @interface CreatePlaylistRequestBodyProducerCopyrightLine
 */
export interface CreatePlaylistRequestBodyProducerCopyrightLine {
    /**
     * Copyright year (4 characters)
     * @type {string}
     * @memberof CreatePlaylistRequestBodyProducerCopyrightLine
     */
    year: string;
    /**
     * Copyright text
     * @type {string}
     * @memberof CreatePlaylistRequestBodyProducerCopyrightLine
     */
    text: string;
}

/**
 * Check if a given object implements the CreatePlaylistRequestBodyProducerCopyrightLine interface.
 */
export function instanceOfCreatePlaylistRequestBodyProducerCopyrightLine(value: object): value is CreatePlaylistRequestBodyProducerCopyrightLine {
    let isInstance = true;
    isInstance = isInstance && "year" in value && value["year"] !== undefined;
    isInstance = isInstance && "text" in value && value["text"] !== undefined;

    return isInstance;
}

export function CreatePlaylistRequestBodyProducerCopyrightLineFromJSON(json: any): CreatePlaylistRequestBodyProducerCopyrightLine {
    return CreatePlaylistRequestBodyProducerCopyrightLineFromJSONTyped(json, false);
}

export function CreatePlaylistRequestBodyProducerCopyrightLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlaylistRequestBodyProducerCopyrightLine {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'year': json['year'],
        'text': json['text'],
    };
}

export function CreatePlaylistRequestBodyProducerCopyrightLineToJSON(value?: CreatePlaylistRequestBodyProducerCopyrightLine | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'year': value.year,
        'text': value.text,
    };
}

